import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import { DateFormat, getFormatDate } from '@cp/src/utils/DateHelper';
import { CallSummary } from '../../interface';
import { TDME_AUDIT_TEAMS, TeamType } from '../auditEnums';

interface AuditDetailsSectionProps {
  callSummary?: CallSummary;
  isTDME?: boolean;
}

const formatCallDateTime = (callDateTime?: string) => {
  if (!callDateTime) return null;
  return getFormatDate(callDateTime, DateFormat.DD_MMM_YYYY__hh_mm_a);
};

const AuditDetailsSection = (props: AuditDetailsSectionProps) => {
  const { callSummary, isTDME } = props;
  const isAuditDetailsHidden = isTDME && !TDME_AUDIT_TEAMS.includes(callSummary?.team as TeamType);

  if (isAuditDetailsHidden) return null;

  const auditDetailsFields = [
    { key: 'auditTLName', label: 'Final Audit', isDate: false },
    { key: 'tlAuditTimestamp', label: 'Final Audit Date', isDate: true },
    { key: 'auditAgentName', label: 'Audit', isDate: false },
    { key: 'agentAuditTimestamp', label: 'Audit Date', isDate: true },
    { key: 'callingAgentName', label: 'Calling Agent', isDate: false },
    {
      key: 'callingAgentReportingManagerName',
      label: 'Reporting Manager',
      isDate: false
    }
  ] as const;

  return (
    <div className="bg-[var(--bg-primary-warm)] px-4 py-3 grid grid-cols-2 gap-y-3 gap-x-8 rounded-xl">
      {auditDetailsFields.map(({ key, label, isDate }) => {
        const value = callSummary?.[key];
        if (!value) return null;
        return (
          <div key={key} className="flex flex-col">
            <Typography variant="p5" color="var(--grayscale-3)">
              {label}
            </Typography>
            <Typography variant="p5" color="var(--grayscale-1)">
              {isDate ? formatCallDateTime(value) : value}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default AuditDetailsSection;
